import { emit } from "infrastructure/eventHub";

export function registerCampaignSocketListeners(socket) {
  socket.on("campaignMessagesDetailsFileProgress", payload => {
    emit("campaign", "file", "progress", "both", {
      file: "messages",
      status: payload
    });
  });

  socket.on("campaignResponsesDetailsFileProgress", payload => {
    emit("campaign", "file", "progress", "both", {
      file: "responses",
      status: payload
    });
  });

  socket.on("campaignsMessagesMassiveFileProgress", payload => {
    emit("campaign", "massiveFile", "progress", "both", payload);
  });
}
